import { render, staticRenderFns } from "./page-footer.vue?vue&type=template&id=58437aae"
import script from "./page-footer.js?vue&type=script&lang=js&external"
export * from "./page-footer.js?vue&type=script&lang=js&external"
import style0 from "./page-footer.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports